/* eslint-disable */
import { gsap } from '../../../node_modules/gsap';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin';
import { CustomEase } from 'gsap/CustomEase';

import inView from 'in-view';

gsap.registerPlugin(MotionPathPlugin);
gsap.registerPlugin(CustomEase);

export default {
  init() {
    let trigeredDesk = false;
    let trigeredMob = false;
    inView.offset(100);
    inView('#Path_1').on('enter', el => {
      setTimeout(() => {
        el.classList.add('founded');
        if (!trigeredDesk) {
          this.deskKringelis();
          trigeredDesk = true;
        }
      }, 300);
    });
    inView('#mobile-line').on('enter', el => {
      setTimeout(() => {
        el.classList.add('founded');
        if (!trigeredMob) {
          this.mobKringelis();
          trigeredMob = true;
        }
      }, 300);
    });

    const line = document.getElementById('Path_1');
    if (line) {
      const lineLength = line.getTotalLength();
      line.style.strokeDasharray = lineLength + 'px';
      line.style.strokeDashoffset = lineLength + 'px';
    }

    const mobileLine = document.getElementById('mobile-line');
    if (line) {
      const moblineLength = mobileLine.getTotalLength();
      mobileLine.style.strokeDasharray = moblineLength + 'px';
      mobileLine.style.strokeDashoffset = moblineLength + 'px';
    }

    const kringels = document.querySelectorAll('.js-kringel-wrap');
    kringels.forEach(kringel => {
      kringel.classList.remove('js-kringel-wrap--hidden');
    });
  },
  deskKringelis() {
    CustomEase.create('cubic', '0.25, 0.46, 0.45, 0.94');

    gsap.to('#Path_3', {
      motionPath: {
        path: '#Path_1',
        align: '#Path_1',
        alignOrigin: [0.5, 0.5]
      },
      duration: 5,
      ease: 'cubic'
    });
  },
  mobKringelis() {
    CustomEase.create('cubic', '0.25, 0.46, 0.45, 0.94');

    gsap.to('#mobile-dot', {
      motionPath: {
        path: '#mobile-line',
        align: '#mobile-line',
        alignOrigin: [0.5, 0.5]
      },
      duration: 5,
      ease: 'cubic'
    });
  }
};
